import { render, staticRenderFns } from "./GekkoMenu.vue?vue&type=template&id=6593b962&"
import script from "./GekkoMenu.vue?vue&type=script&lang=js&"
export * from "./GekkoMenu.vue?vue&type=script&lang=js&"
import style0 from "./GekkoMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports